//ts:ignore
const NotifyBeforeClose = () => {
    let target = document.querySelector('input');  
    target && target.addEventListener('change', function () {  
         
    });  
}
export default NotifyBeforeClose